/**
 * ÜRÜN GALERİSİ — OTOMATİK GEÇİŞİN KAPSAMI
 *
 * Otomatik geçişin kendisi Swiper'a KURULUM anında veriliyor
 * (bkz. main-product__media-gallery.liquid: "autoplay" + "speed" + "loop").
 * Sebebi: Swiper 11'de autoplay parametrelerini kurulumdan SONRA değiştirmek
 * güvenilir çalışmıyor — autoplay "running" görünüp slaytları hiç ilerletmiyor.
 *
 * Bu dosyanın işi: otomatik geçişi masaüstünde açık tutmak, mobilde ve "hareketi
 * azalt" tercihinde DURDURMAK; ayrıca kesintisiz akış için uzun tutulan `speed`
 * değerini mobilde düşürerek elle kaydırmanın normal hızda kalmasını sağlamak.
 *
 * Not: Kaft eski Swiper (v6) kullandığı için orada kesintisiz akış `delay: 0`
 * ile yapılıyor. Swiper 11'de `delay: 0` autoplay'i tamamen durduruyor, bu yüzden
 * burada pozitif gecikme + uzun geçiş süresi ile yumuşak bir akış kuruldu.
 */
(function () {
  'use strict';

  var DESKTOP_QUERY = '(min-width: 750px)';
  var SELECTOR = 'swiper-product-gallery[handle="product-gallery"]';
  // Kesintisiz akış için kurulumdaki `speed` uzun (ör. 6000). Bu global geçiş
  // süresi mobilde elle kaydırmayı da yavaşlatır; mobilde bu değere düşürüyoruz.
  var SNAPPY_SPEED = 400;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function shouldAutoplay() {
    return window.matchMedia(DESKTOP_QUERY).matches && !prefersReducedMotion();
  }

  function sync(gallery) {
    var swiper = gallery.instance;
    if (!swiper || !swiper.autoplay) return;

    // Kurulumdaki uzun akış hızını bir kez sakla (masaüstünde geri veririz).
    if (typeof gallery.__flowSpeed !== 'number') {
      gallery.__flowSpeed = swiper.params.speed;
    }

    if (shouldAutoplay()) {
      swiper.params.speed = gallery.__flowSpeed;
      if (!swiper.autoplay.running) swiper.autoplay.start();
    } else {
      if (swiper.autoplay.running) swiper.autoplay.stop();
      // Mobilde / hareket azaltıldığında elle kaydırma normal hızda kalsın.
      swiper.params.speed = SNAPPY_SPEED;
    }
  }

  /**
   * Galeri kendi Swiper örneğini DOMContentLoaded'da kuruyor ve `instance` olarak
   * saklıyor. Sıralamaya güvenmemek için örnek hazır olana kadar kısa aralıklarla yokluyoruz.
   */
  function whenReady(gallery, callback) {
    var attempts = 0;
    var MAX_ATTEMPTS = 60; // ~3 sn

    (function poll() {
      if (gallery.instance) {
        callback();
        return;
      }
      if (++attempts >= MAX_ATTEMPTS) return;
      setTimeout(poll, 50);
    })();
  }

  function init() {
    var galleries = document.querySelectorAll(SELECTOR);
    if (!galleries.length) return;

    Array.prototype.forEach.call(galleries, function (gallery) {
      whenReady(gallery, function () {
        sync(gallery);

        var mediaQuery = window.matchMedia(DESKTOP_QUERY);
        var onChange = function () {
          sync(gallery);
        };

        if (mediaQuery.addEventListener) {
          mediaQuery.addEventListener('change', onChange);
        } else if (mediaQuery.addListener) {
          mediaQuery.addListener(onChange);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
